export default __webpack_public_path__ + "static/media/1.46b3703a.png";